import React from 'react';
import {FormattedMessage} from 'react-intl';

function NoRows(props) {
  return (
    <tr>
      <th scope="row" colSpan={props.colSpan || 5}
          className="text-left text-sm-center">
        <FormattedMessage id="messages.no_data"/>
      </th>
    </tr>
  );
}

export {NoRows};
